export enum SHADE_GROUP {
    ALL = 'all',
    RED = 'red',
    NUDE = 'nude',
    PURPLE = 'purple',
    ORANGE = 'orange',
    NEW = 'new',
    CREME = 'creme',
    CHROME = 'chrome',
    DEEP = 'deep',
    LIGHT = 'light',
    LIMITED_EDITION = 'limited-edition',
    MEDIUM = 'medium',
    MATTE = 'matte',
    MATTE_FINISH = 'mate-finish',
    METALLIC = 'metallic',
    FOIL_FINISH = 'foil-finish',
    SHINE = 'shine',
    SPARKLE = 'sparkle',
    SHIMMER = 'shimmer'
}
